if (typeof window.appJs === "undefined") {
    console.error("appJs is not defined");
    window.appJs = {};
}

const productFilter = {};

(function (productFilterApp, appJsApp) {
    let filterModel = {
        PetTypeId: 0,
        LifeStage: null,
        BreedSize: null,
        ProductType: null,
        IsTreat: false
    };
    let fromPopState = false;
    let blockPopstateEvent = true;
    let browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            const basePath = $(".js-product-filter-results").data("url");
            let pathArray = [];

            if (filterModel.LifeStage) {
                pathArray.push(filterModel.LifeStage);
            }
            if (filterModel.BreedSize) {
                pathArray.push(filterModel.BreedSize);
            }
            if (filterModel.ProductType) {
                pathArray.push(filterModel.ProductType);
            }

            let path = pathArray.join("/");
            path = path === "" || path.endsWith("/") ? path : path + "/";
            history.pushState(null, null, basePath + path);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.LifeStage = null;
        filterModel.BreedSize = null;
        filterModel.ProductType = null;

        const pathArray = window.location.pathname.substr(1).split("/").filter(x => x);
        const lifeStageList = $(".js-product-filter-results").data("lifestagelist");
        const breedSizeList = $(".js-product-filter-results").data("breedsizelist");
        const productTypeList = $(".js-product-filter-results").data("producttypelist");

        if (window.location.pathname.length > 1 && pathArray.length > 1) {
            for (let i = 0; i < pathArray.length; i++) {

                const path = pathArray[i];
                if (lifeStageList.includes(path)) {
                    filterModel.LifeStage = path;
                } else if (breedSizeList.includes(path)) {
                    filterModel.BreedSize = path;
                } else if (productTypeList.includes(path)) {
                    filterModel.ProductType = path;
                }
            }
        }

        productFilter.GetProducts();

        if (filterModel.LifeStage !== null && filterModel.LifeStage !== "") {
            setActiveButton("js-product-filter-lifestage", filterModel.LifeStage);
        }
        if (filterModel.LifeStage === null && filterModel.LifeStage !== "") {
            setActiveButton("js-product-filter-breedsize", "");
        }
        if (filterModel.ProductType === null && filterModel.ProductType !== "") {
            setActiveButton("js-product-filter-producttype", "");
        }
    }

    function setActiveButton(className, valueToSelect) {
        const element = document.getElementsByClassName(className);
        element[0].value = valueToSelect;
    }

    productFilterApp.GetProducts = function () {
        $.ajax({
            url: "/umbraco/surface/BHProductSurface/GetAjaxFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-product-pettype-filter").html(data);
                $("head title").text($(".js-product-filter-results").data("metatitle"));

                var noBannerClass = "page--no-banner";
                $("body").removeClass(noBannerClass);
                if ($(".js-product-filter-results").data("nobanner")) {
                    $("body").addClass(noBannerClass);
                }
                
                appJsApp.InitializeAccordion();

                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    $(document).ready(function () {
        $(document).on("click", ".js-product-filter-submit", function () {
            filterModel.PetTypeId = $(".js-product-filter-results").data("pettypeid");
            filterModel.LifeStage = $(".js-product-filter-lifestage.is-active").val();
            filterModel.BreedSize = $(".js-product-filter-breedsize.is-active").val();
            filterModel.ProductType = $(".js-product-filter-producttype.is-active").val();
            productFilterApp.GetProducts();
            $(".js-close-toggle").click();
        });

        $(document).on("click", ".js-product-filter-lifestage", function (e) {
            e.preventDefault();
            onFilterClick($(this), ".js-product-filter-lifestage");
        });

        $(document).on("click", ".js-product-filter-breedsize", function (e) {
            e.preventDefault();
            onFilterClick($(this), ".js-product-filter-breedsize");
        });

        $(document).on("click", ".js-product-filter-producttype", function (e) {
            e.preventDefault();
            onFilterClick($(this), ".js-product-filter-producttype");
        });

        function onFilterClick(thisObj, className) {
            thisObj.toggleClass("is-active");
            $(className).not(thisObj).removeClass("is-active");
            thisObj.blur();
        }
    });

})(productFilter, appJs);
